module.exports = __webpack_public_path__ + "img/concept-microservices.d50608f3.svg";